import { ClipboardCheck, Package, Truck, Scale, Users } from 'lucide-react';
import { Reveal } from '@/components/motion/Reveal';
import { FeaturesCTA } from './FeaturesCTA';

const valueProps = [
  {
    icon: ClipboardCheck,
    title: 'Plan smarter',
    description:
      'Design weekly menus around your camper headcounts, dietary needs, and serving sizes — no more guesswork.',
  },
  {
    icon: Package,
    title: 'Inventory in real time',
    description:
      "Know exactly what's in your kitchen, what's running low, and what's already covered for next week's meals.",
  },
  {
    icon: Truck,
    title: 'Order with confidence',
    description:
      'Generate Sysco-ready purchase orders automatically. No CSV uploads, no manual math — just one click.',
  },
  {
    icon: Scale,
    title: 'Reduce waste, save money',
    description:
      'Balance portions and minimize leftovers, saving hundreds across each camp season.',
  },
  {
    icon: Users,
    title: 'Empower your team',
    description:
      'Give chefs, volunteers, and staff shared access to recipes, inventory, and the daily meal schedule.',
  },
];

export const ValueProposition = () => {
  return (
    <section id="features" className="relative bg-sand py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <span className="eyebrow">Capabilities</span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display text-display-md text-midnight-green mt-5 text-balance">
              Everything you need to run your camp kitchen smoothly.
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-5 max-w-prose font-inter text-base text-slate/70 text-pretty">
              From menu planning to Sysco ordering, CampChef Pro turns kitchen chaos into a calm, repeatable
              system — without piling on more tools.
            </p>
          </Reveal>
        </div>

        {/* Editorial list, no card-in-card */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-14 border-t border-foreground/10 pt-14">
          {valueProps.map((prop, i) => {
            const Icon = prop.icon;
            return (
              <Reveal key={prop.title} delay={i * 70}>
                <div className="group">
                  <Icon className="h-6 w-6 text-copper" strokeWidth={1.6} />
                  <h3 className="mt-5 font-display text-2xl text-midnight-green">{prop.title}</h3>
                  <p className="mt-3 font-inter text-[15px] text-slate/75 leading-relaxed text-pretty max-w-[38ch]">
                    {prop.description}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-20">
          <FeaturesCTA />
        </div>
      </div>
    </section>
  );
};
